module.exports = __webpack_public_path__ + "img/photo_2022-11-07_21-45-42.71044669.jpg";